<template>
    <div class="tabs">
        <div class="flex flex-col relative">
            <ul class="flex flex-row">
                <li v-for="tab in tabs" class="tab-item">
                    <a :href="tab.href"
                       v-ripple="'rgba(237,108,8, 0.2)'"
                       :ref="tab.itemKey"
                       class="block py-2 px-4 transition text-sm text-gray-400 font-bold"
                       :class="{ 'border-orange-500 text-orange-500 selected': tab.isActive }"
                       @click="(e) => selectTab(tab, e)">
                        {{ tab.name }}
                    </a>
                </li>
            </ul>
            <span class="w-full relative" :style="{ height: '2px' }">
                <span ref="activeLine" class="transition absolute bg-orange-400" :style="{ height: '2px' }"></span>
            </span>
        </div>
        
        <div class="bg-white shadow-md px-6 py-6 transition">
            <slot />
        </div>
    </div>
</template>

<script>

    export default {
        name: "Tabs",

        data() {
            return {
                tabs: [],
                activeTab: null
            };
        },

        created() {
            this.tabs = this.$children;
        },

        mounted() {
            let routeHash = this.$route.hash;

            if (routeHash) {
                let hash = routeHash.substr(1, routeHash.length);
                this.selectTab({itemKey: hash});
            } else {
                this.selectTab(null)
            }


            setTimeout(() => this.drawActiveLine(this.activeTab), 100);
        },

        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = selectedTab ? (tab.itemKey === selectedTab.itemKey) : tab.defaultSelected;
                    if (tab.isActive)
                        this.activeTab = tab;
                });

                if (this.activeTab !== null)
                    setTimeout(() => this.drawActiveLine(this.activeTab), 50);
            },

            drawActiveLine(tab) {
                let activeName = tab.itemKey;
                let activeTab = this.$refs[activeName][0];

                this.$refs.activeLine.style.left = activeTab.offsetLeft + "px"; // Set left position
                this.$refs.activeLine.style.width = activeTab.offsetWidth + "px"; // Set width
            }
        }
    }
</script>

<style lang="scss">
    .tabs {
        ul {
            li.tab-item {
                a {
                    @apply text-gray-400;
                    &.selected {
                        @apply text-orange-500;
                    }
                }
            }
        }
    }
</style>